import { Link } from 'react-router-dom';
import { posts } from '@/mocks/posts';
import PostCard from '@/components/feature/PostCard';
import { formatViews, getCategoryBySlug } from '@/utils/site';

export default function FeaturedSection() {
  const ranked = [...posts].sort((a, b) => b.views - a.views);
  const top = ranked[0];
  const secondary = ranked.slice(1, 3);
  const ranking = ranked.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-label tracking-[0.2em] text-primary-600 uppercase mb-3">
            <i className="ri-subtract-line" />
            本周热门
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">这周被回看最多的名场面</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-7">
            按围观热度排序，先看大家都在讨论什么，再决定要不要把整段回放翻出来。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          <div className="lg:col-span-2 flex flex-col gap-6">
            <PostCard post={top} layout="wide" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {secondary.map((post) => (
                <PostCard key={post.id} post={post} layout="grid" />
              ))}
            </div>
          </div>

          <aside className="lg:col-span-1" aria-label="热门排行榜">
            <div className="bg-background-100 rounded-lg border border-background-200 p-5 md:p-6 h-full">
              <div className="flex items-center gap-2 pb-4 border-b border-background-200">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className="ri-trophy-line" />
                </span>
                <h3 className="font-heading text-lg text-foreground-950">高能热榜</h3>
              </div>
              <ul className="mt-4 space-y-1">
                {ranking.map((post, index) => {
                  const category = getCategoryBySlug(post.categorySlug);
                  return (
                    <li key={post.id}>
                      <Link
                        to={`/detail/${post.id}`}
                        className="group flex items-start gap-3 py-3 border-b border-background-200 last:border-0"
                      >
                        <span
                          className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md font-heading text-sm ${
                            index < 3
                              ? 'bg-primary-500 text-background-50'
                              : 'bg-background-200 text-foreground-700'
                          }`}
                        >
                          {index + 1}
                        </span>
                        <span className="min-w-0">
                          <span className="block text-sm text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                            {post.title}
                          </span>
                          <span className="mt-1 block text-[11px] text-foreground-500">
                            {category?.name} · {formatViews(post.views)} 次围观
                          </span>
                        </span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}